import { get } from 'lodash/fp';
import axios from './axios';

export default (jobUid, designUid) => (
  axios.delete(`/jobs/${jobUid}/designs`, { params: { designUid } })
    .then(get('data'))
);
